RivalIQ.apps.Insights.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.LinkListItem = views.ContentListItem.extend({
        template: '#contentLinkListItemTemplate'
    });
});
